import mutations from './bnoSelect.mutations'
import actions from './bnoSelect.actions'
import getters from './bnoSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
